import { Alert, Box, Typography } from '@mui/material';
import React from 'react';
import { StyledButton } from '../components/styles/StyledButtons';
import { StyledHeading } from '../components/styles/styles';
import { Palette } from 'Palette';
import { useNavigate } from 'react-router-dom';

const PasswordChangeSent: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 3,
        backgroundColor: '#f5f5f5',
      }}
    >
      <Box
        sx={{
          maxWidth: 600,
          width: '100%',
          backgroundColor: 'white',
          padding: 4,
          borderRadius: 2,
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        <StyledHeading
          tone="tone1"
          sx={{
            textAlign: 'center',
            marginBottom: 3,
            fontSize: '1.75rem',
            fontWeight: 600,
          }}
        >
          Password Change Email Sent
        </StyledHeading>

        <Alert
          severity="info"
          sx={{
            marginBottom: 3,
            '& .MuiAlert-message': {
              width: '100%',
            },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: '1rem',
              lineHeight: 1.6,
              color: Palette.tone1.text,
            }}
          >
            A password change link has been sent to your email address. Please check your inbox and
            follow the instructions to complete your password change.
          </Typography>
        </Alert>

        <Alert
          severity="warning"
          sx={{
            marginBottom: 3,
            '& .MuiAlert-message': {
              width: '100%',
            },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: '1rem',
              lineHeight: 1.6,
              color: Palette.tone1.text,
            }}
          >
            <strong>You have been logged out.</strong> Once you have completed your password change,
            please log in again with your new password.
          </Typography>
        </Alert>

        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}>
          <StyledButton
            onClick={() => navigate('/login')}
            sx={{
              backgroundColor: Palette.tone1.buttonBg,
              color: Palette.tone1.buttonText,
              '&:hover': {
                backgroundColor: Palette.tone1.activeBg,
                color: Palette.tone1.activeText,
              },
              padding: '10px 24px',
            }}
          >
            Go to Login
          </StyledButton>
        </Box>
      </Box>
    </Box>
  );
};

export default PasswordChangeSent;
